import { selectAtRandom } from '@fortem-monorepo/js-utilities'

export const taskNames = [
  'swapagg-ctrl',
  'nt_parse_deals_schedule',
  'nt_deals_schedule',
  'primary-issuance-email',
  'fx_transaction_report',
  'new_db_eod_prices_from_old_db',
  'nt-valuations-and-fxfwd-extracts',
  'nt_funds_navs',
  'citi_valuations_equity_swap',
  'citi_valuations_commo',
  'citi_valuations',
  'citi_strategy_component_valuations',
  'barclays_parse_strategy_component_valuations.py',
  'barclays_strategy_component_valuations.py',
  'info_bonds_old_to_new',
  'jpm_parse_strategy_component_valuations.py',
  'ms_product_pricings',
  'jpm_strategy_component_valuations',
  'barc_product_pricings',
  'premialab_fcgms_private_track',
  'nt_trade_confirmations',
  'bonds-bbg-staticdata-cf-schedule',
  'super_global_service_funds_prices',
  'citi_product_pricings',
  'fund_credit_spreads',
  'baml_product_pricings_structured',
  'nomura_product_pricings',
  'soge_product_pricings',
  'bnp_product_pricings',
  'nt_cash_reports',
  'jpm_product_pricings',
  'website_historical_prices',
  'nt_funds_prices',
  'baml_product_pricings',
  'baml_product_pricings_swap',
  'subscription-redemption-morning-summary',
  'gs_product_pricings',
  'prod_to_dev_db',
  'email_eod_trades',
  'holidays',
  'purge-logs',
  'email_maturing_products',
  'email_eom_prices',
  'fcpgf_bear_scenario',
].sort()

export const allScheduledTasks = taskNames.map((taskName) => {
  return {
    taskName,
    type: selectAtRandom(['email', 'email', 'email', 'email', 'sftp'] as const),
    status: selectAtRandom([
      'preparing',
      'active',
      'active',
      'active',
      'active',
      'active',
      'active',
      'active',
      'active',
      'active',
      'active',
      'inactive',
    ] as const),
  }
})
